import {
  BackendModule,
  InitOptions,
  ReadCallback,
  ResourceKey,
  Services,
} from "i18next";

class I18NextLivingMapBackend implements BackendModule<{}> {
  public type: "backend" = "backend";

  public langMap: Map<string, ResourceKey> | null = null;

  init(
    _services: Services,
    _backendOptions: {},
    _i18nextOptions: InitOptions,
  ): void {
    // no-op
  }

  public async loadLangMap(language: string): Promise<void> {
    if (this.langMap == null) {
      this.langMap = new Map<string, ResourceKey>();
    }

    if (!this.langMap.has(language)) {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_LANGUAGE_API_URL}/${language}.json`,
        );
        const rJson = await res.json();
        this.langMap.set(language, rJson);
      } catch (e) {
        this.langMap.set(language, {});
      }
    }
  }

  read(language: string, _namespace: string, callback: ReadCallback): void {
    this.loadLangMap(language).then(() => {
      callback(null, this.langMap?.get(language));
    });
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new I18NextLivingMapBackend();
